import { makeStyles } from '@material-ui/core';
import { COLUMN_WIDTHS, COLUMN_MIN_WIDTHS } from '../column-widths';

// Left indent for the option's tree connector. The product-name column gives
// this much width back (see `productInfo`) so an indented option row never
// needs more total width than its parent — otherwise only nested rows overflow
// and cramp the pricing columns on narrow panels.
const OPTION_INDENT = 61;

export const useOptionRowStyles = makeStyles(() => ({
  optionRowWrapper: {
    position: 'relative',
    paddingLeft: `${OPTION_INDENT}px`
  },
  connectingLineContainer: {
    position: 'absolute',
    left: '33px',
    top: 0,
    bottom: 0,
    width: '31px'
  },
  verticalLine: {
    position: 'absolute',
    left: 0,
    top: '-70px',
    width: '1px',
    height: 'calc(100% + 100px)',
    background:
      'repeating-linear-gradient(to bottom, #AFBAC6 0, #AFBAC6 5px, transparent 4px, transparent 11px)'
  },
  verticalLineLastChild: {
    position: 'absolute',
    left: 0,
    top: '-50px',
    width: '1px',
    height: '90px',
    background:
      'repeating-linear-gradient(to bottom, #AFBAC6 0, #AFBAC6 5px, transparent 4px, transparent 11px)'
  },
  cornerPiece: {
    position: 'absolute',
    left: 0,
    top: '37px',
    width: '7px',
    height: '7px',
    borderLeft: '1px solid #AFBAC6',
    borderBottom: '1px solid #AFBAC6',
    borderBottomLeftRadius: '5px'
  },
  horizontalConnector: {
    position: 'absolute',
    left: '11px',
    top: '42px',
    width: '25px',
    height: '1px',
    background:
      'repeating-linear-gradient(to right, #AFBAC6 0, #AFBAC6 5px, transparent 5px, transparent 11px)'
  },
  rowContainer: {
    backgroundColor: '#FFFFFF',
    borderRadius: '12px',
    padding: '12px 0',
    position: 'relative',
    width: '100%'
  },
  productContainer: {
    alignItems: 'center',
    display: 'flex',
    gap: '16px',
    minHeight: '86px'
  },
  productInfo: {
    // Shrink the floor by the indent so the option row's total min width
    // matches the parent row's and the pricing columns stay aligned / un-cramped.
    minWidth: `calc(${COLUMN_MIN_WIDTHS.productInfo} - ${OPTION_INDENT}px)`,
    flex: 1
  },
  qtyColumn: {
    width: COLUMN_WIDTHS.qty,
    minWidth: COLUMN_MIN_WIDTHS.qty,
    flexShrink: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  unitPriceColumn: {
    width: COLUMN_WIDTHS.unitPrice,
    minWidth: COLUMN_MIN_WIDTHS.unitPrice,
    flexShrink: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  gpColumn: {
    width: COLUMN_WIDTHS.gp,
    minWidth: COLUMN_MIN_WIDTHS.gp,
    flexShrink: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  totalPriceColumn: {
    width: COLUMN_WIDTHS.totalPrice,
    minWidth: COLUMN_MIN_WIDTHS.totalPrice,
    flexShrink: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  actionColumn: {
    width: COLUMN_WIDTHS.action,
    flexShrink: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  }
}));
